import BusinessSlotReservation from "./BusinessSlotReservation"
import BasicReservationForm from "./BasicReservationForm"
import PublicHotelReservationForm from "./PublicHotelReservationForm"
import { useState, useEffect } from "react"
import {useParams } from "react-router-dom"
import axios from "axios"
import { useAuth } from "../context/AuthContext"
import LoginWithoutNavbar from "./LoginWithoutNavbar"
import Navbar from "./Navbar"
import Cookies from "js-cookie"
import PublicLessonsReservation from "./PublicLessonsReservation"

const AllPublicReservationForm = () => {
  const [publicData, setPublicData] = useState(null)
  const { businessId } = useParams()
  const { user, userToken, businessToken, business } = useAuth()
  const [quest, setQuest] = useState(null)
  const [isQuestAuthenticated, setIsQuestAuthenticated] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchPublicData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/business/public/${businessId}`);
        setPublicData(response.data);
      } catch (err) {
        console.log(err.response?.data.message || err.message);
      }
    };
    fetchPublicData();
  }, [businessId]);

  useEffect(() => {
    const savedQuest = Cookies.get("questData");
    if (savedQuest) {
      try {
        setQuest(JSON.parse(savedQuest));
      } catch (error) {
        console.error("Chyba při parsování questData:", error);
      }
    }
  }, []);

    useEffect(() => {
      const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      scrollToTop()
    }, [])

  useEffect(() => {
    if (business || user || quest ) {
      setLoading(false)
    } else {
      setLoading(false)
    }
  }, [business, user, quest])

  useEffect(() => {
    if (quest) {
      setIsQuestAuthenticated(true);
      
    }
  }, [quest]);

  // Společný renderovací kód pro všechny typy uživatelů
  const renderReservationForms = () => {
    return (
      <div>
        {publicData && (
          <div>
            {!publicData.groupLessons && <h2 className='services-title'>Rezervace</h2>}
            {publicData.salonReservation && <BusinessSlotReservation quest={quest} />}
            {publicData.basicReservation && <BasicReservationForm quest={quest} />}
            {publicData.hotelReservation && <PublicHotelReservationForm quest={quest} />}
            {publicData.groupLessons && <PublicLessonsReservation />}
          </div>
        )}
      </div>
    );
  };

  // Zpracování autentifikace a renderování
  if (user && userToken) {
    return (
      <div className="min-height">
        <Navbar businessId={businessId} publicName={publicData?.name} />
        {renderReservationForms()}
      </div>
    );
  } else if (business && businessToken) {
    return (
      <div className="min-height">
        <Navbar businessId={businessId} publicName={publicData?.name} />
        {renderReservationForms()}
        
      </div>
    );
  } else if (quest && isQuestAuthenticated) {
    return (
      <div className="min-height">
        <Navbar businessId={businessId} publicName={publicData?.name} />
        {renderReservationForms()}
      </div>
    );
  }

  if (loading) {
    return <div className="loading-spinner center-spinner"></div>
  }
  // Pokud není žádný validní token, ukáže se přihlašovací formulář
  return (
    <div className="min-height">
      <Navbar businessId={businessId} publicName={publicData?.name} />
      <LoginWithoutNavbar />
    </div>
  );
};

export default AllPublicReservationForm;